import { render, staticRenderFns } from "./TrainingFilesList.vue?vue&type=template&id=7bb78972&scoped=true"
import script from "./TrainingFilesList.vue?vue&type=script&lang=js"
export * from "./TrainingFilesList.vue?vue&type=script&lang=js"
import style0 from "./TrainingFilesList.vue?vue&type=style&index=0&id=7bb78972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb78972",
  null
  
)

export default component.exports